/**
 * The date ranges a shop actually asks for.
 *
 * Computed in the browser and sent as plain from/to dates, because the
 * backend already filters on those — "this week" is a question about the
 * user's calendar, not something the server should be guessing at from its
 * own timezone.
 */
const iso = (d) => {
  // Local date, not toISOString(): that converts to UTC first, so late in
  // the evening in IST "today" would come back as tomorrow's date.
  const pad = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

const shift = (days) => {
  const d = new Date()
  d.setDate(d.getDate() + days)
  return d
}

export const DATE_RANGES = {
  '': { label: 'Any date', range: () => ({}) },
  today: {
    label: 'Today',
    range: () => ({ date_from: iso(new Date()), date_to: iso(new Date()) }),
  },
  yesterday: {
    label: 'Yesterday',
    range: () => ({ date_from: iso(shift(-1)), date_to: iso(shift(-1)) }),
  },
  this_week: {
    label: 'This week',
    // Monday to today. A trade week here starts on Monday, and nobody wants
    // Sunday's orders filed under next week.
    range: () => {
      const now = new Date()
      const back = (now.getDay() + 6) % 7
      return { date_from: iso(shift(-back)), date_to: iso(now) }
    },
  },
  last_7: {
    label: 'Last 7 days',
    range: () => ({ date_from: iso(shift(-6)), date_to: iso(new Date()) }),
  },
  this_month: {
    label: 'This month',
    range: () => {
      const now = new Date()
      const first = new Date(now.getFullYear(), now.getMonth(), 1)
      return { date_from: iso(first), date_to: iso(now) }
    },
  },
  last_month: {
    label: 'Last month',
    range: () => {
      const now = new Date()
      const first = new Date(now.getFullYear(), now.getMonth() - 1, 1)
      const last = new Date(now.getFullYear(), now.getMonth(), 0)
      return { date_from: iso(first), date_to: iso(last) }
    },
  },
  custom: { label: 'Custom range…', range: () => ({}) },
}

export { iso as isoDate }
